import { render, staticRenderFns } from "./NotificationMenu.vue?vue&type=template&id=08dcfaa6&scoped=true"
import script from "./NotificationMenu.vue?vue&type=script&lang=js"
export * from "./NotificationMenu.vue?vue&type=script&lang=js"
import style0 from "./NotificationMenu.vue?vue&type=style&index=0&id=08dcfaa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dcfaa6",
  null
  
)

export default component.exports